import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  TravelRequestDetail,
  type TravelRequestDetailConstructor,
} from './TravelRequestDetail'
import { TravelStatuses } from '../enums/TravelStatusEnum'
import { TravelApprovalLogConstructorFactory } from '../TravelApprovalLog'
import { TravelDestinationConstructorFactory } from '../TravelDestination'

export const TravelRequestDetailConstructorFactory =
  Factory.Sync.makeFactory<TravelRequestDetailConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    status: TravelStatuses.PENDING,
    travelBudget: Factory.each(() => faker.random.number()),
    purpose: Factory.each(() => faker.lorem.sentence()),
    details: null,
    dateCreated: Factory.each(() => faker.date.past().toISOString()),
    dateLastModified: Factory.each(() => faker.date.past().toISOString()),
    canEdit: true,
    canDelete: true,
    canApprove: false,
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    requester: Factory.each(() => ({
      id: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      email: faker.internet.email(),
    })),
    nextApprover: null,
    primaryCategory: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.address.city(),
    })),
    secondaryCategory: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.commerce.department(),
    })),
    secondaryCategoryId: Factory.each(() => faker.random.number()),
    destinations: Factory.each(() => [
      TravelDestinationConstructorFactory.build(),
    ]),
    logs: Factory.each(() => [TravelApprovalLogConstructorFactory.build()]),
    nextApproverChoices: null,
  })

export const TravelRequestDetailFactory = EntityFactory(
  TravelRequestDetail,
  TravelRequestDetailConstructorFactory
)
